<div class="form-layout">
  <div class="background" [ngStyle]="{ 'background-image': 'url(' + backgroundImageUrl + ')' }">
    @if (formSettings.ShowEntityLogo || formSettings.EntityName) {
      <div class="logo-container">
        @if (formSettings.EntityLogoUrl) {
          <span class="image-container">
            <img [src]="formSettings.EntityLogoUrl" alt="{{ formSettings.EntityName }} Logo" class="logo" />
          </span>
        }
        @if (formSettings.EntityName) {
          <span class="entity-text">
            {{ formSettings.EntityName }}
          </span>
        }
      </div>
    }
  </div>

  <div class="form-container">
    <div class="form-header">
      @if (this.showProjectDetails && formSettings.ShowProjectLogo && formSettings.ProjectLogoUrl) {
        <span class="image-container">
          <img [src]="formSettings.ProjectLogoUrl" alt="{{ this.projectLogoAltText }}" class="project-logo" />
        </span>
      }

      <div #gtWrapper class="gtranslate_wrapper"></div>
    </div>

    <div class="form-content">
      <ng-content></ng-content>
    </div>

    @if (formSettings.ProjectFooter) {
      <div class="footer">
        <app-sanitized-html [html]="formSettings.ProjectFooter"></app-sanitized-html>
      </div>
    }
  </div>
</div>
